
































































































































































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import HelpDialog from './HelpDialog.vue'
import * as api from '@/service/step-four'
import { getCurrecyList, getOutsideBankList } from '@/service/common'
import { CreateElement } from 'vue'
import { signBehavior } from '@/service/authentication'
import Daterange from '@/mixins/daterange'
import { StepsFourTextConfig } from '@/config'
import { financialInfo } from '../testData'

@Component({
  components: { HelpDialog },
})
export default class StepsFour extends Mixins(Daterange) {
  @State bidType!: number
  form: any = {}
  bankList: string[] = []
  outsideBankList: any[] = []
  currecyData: any = {}
  /** 对公银行账号验证状态：0 未验证，1 开通虚拟账户成功，2 绑定银行卡成功，3 验证成功 */
  validateStatus = 0
  /** 验证失败错误消息 */
  validateError = ''
  /** 银行账号联系人信息 */
  contacts: any = null
  /** 接收验证短信的手机号 */
  mobile = ''
  showContactsModal = false
  changeMobile = false
  tbBindMobile = ''
  tbBindMobileStr =''
  showHelpDialog = false
  loading = false
  validating = false
  bindingBank = false
  bindBankQuering = false
  timer: any = null
  btnTimer: any = 0
  showReBtn = false
  animation = ''
  previewType: string = ''
  modalVisible = false;
  previewMap: any = {
    bank: require('@/assets/image/bank-card-eg.jpg')
  }
  bankResult: any = 0

  get getTextConfig() {
    if (this.bidType === 7) {
      return StepsFourTextConfig.personal
    }
    if (this.bidType === 8) {
      return StepsFourTextConfig.artist
    }
    return StepsFourTextConfig.normal
  }
  get rules() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this
    return {
      bank_account: [
        {
          required: true,
          message: `请填写${this.getTextConfig['bank_account']['label']}`,
        },
        {
          validator(rule: any, value: any, callback: any) {
            if (self.bidType === 6) {
              if (/^[0-9A-Z]+$/.test(value)) {
                callback()
              } else {
                callback(new Error('对公银行账户格式为大写字母加数字'))
              }
            } else {
              callback()
            }
          },
          trigger: 'change'
        }
      ],
      bank_simple_name: [
        {
          required: true,
          message: '请选择开户银行',
        },
      ],
      bank_name: [
        {
          required: true,
          message: `请填写开户银行${this.bidType === 6 ? '' : '支行'}名称`,
        },
        {
          pattern: this.bidType === 6 && /^[^\u4e00-\u9fa5]+$/,
          message: '开户银行名称不能包含中文',
        },
      ],
      bank_region: [
        {
          required: true,
          message: '请选择开户行所在地',
        },
      ],
      bank_account_url: [
        {
          required: true,
          message: `请上传${this.bidType === 6 ? '银行开户原件' : this.getTextConfig['bank_account_url']['label']}`,
        },
      ],
      ...(this.bidType === 3
        ? {
            tax_invoice_url: [
              {
                required: true,
                message: '请上传一般纳税人资格证/增值税发票照片',
              },
            ],
          }
        : {}),
      bank_currency: [
        {
          required: true,
          message: '请选择银行账号币种',
        },
      ],
      bank_country: [
        {
          required: true,
          message: '请选择开户银行所在国家',
        },
      ],
      bank_detail_addr: [
        {
          required: true,
          message: '请填写开户银行地址',
        },
        {
          pattern: /^[^\u4e00-\u9fa5]+$/,
          message: '开户银行地址不能包含中文',
        },
      ],
      profit_country: [
        {
          required: true,
          message: '请选择账户受益人所在国家',
        },
      ],
      bank_swift_code: [
        {
          required: true,
          message: '请填写SWIFT Code',
        },
      ],
      ...(this.bidType === 7
        ? {}
        : {
            bank_issue_date: [
              {
                required: true,
                message: '请选择开户许可发证时间',
              },
            ],
          }),
    }
  }

  get btnText() {
    return this.validateStatus < 2 ? '请求验证' : '开始验证'
  }

  created() {
    this.initData()
    this.getBankList()
    if (this.bidType === 6) {
      getCurrecyList().then((data) => (this.currecyData = data))
      getOutsideBankList().then((data) => (this.outsideBankList = data))
    }
  }

  mounted() {
    const codeInput: any = this.$refs.codeInput
    codeInput?.$on('change.value', (value: string) => {
      value = value.replace(/\D/g, '')
      this.$set(this.form, 'sms_code', value)
      codeInput.$refs.input.value = value
    })
  }

  beforeDestroy() {
    window.clearTimeout(this.timer)
  }

  @Watch('form.bank_country')
  clearValidate$1() {
    const formRef: any = this.$refs.form
    formRef.clearValidate(['is_osa', 'business_license'])
    this.$set(this.form, 'is_osa', '')
    this.$set(this.form, 'business_license', '')
  }

  @Watch('form.profit_country')
  clearValidate$2(value: string) {
    const formRef: any = this.$refs.form
    formRef.clearValidate('business_license')
    this.$set(this.form, 'business_license', '')
    if (value === 'CHN') {
      formRef.clearValidate('bank_cnaps')
      this.$set(this.form, 'bank_cnaps', '')
    }
  }

  @Watch('form.bank_currency')
  clearValidate$3() {
    const formRef: any = this.$refs.form
    formRef.clearValidate('bank_cnaps')
    this.$set(this.form, 'bank_cnaps', '')
  }

  async initData() {
    this.form = await api.queryFinanceInfo()
    const {
      last_bind_time,
      bank_province,
      bank_city,
      bank_area,
      tb_bind_status,
      tb_bind_mobile,
    } = this.form
    this.$set(
      this.form,
      'bank_region',
      [bank_province, bank_city, bank_area].filter(Boolean)
    )
    if (tb_bind_mobile) {
      let bindMobileStr = tb_bind_mobile.toString()
      this.tbBindMobile = tb_bind_mobile
      this.tbBindMobileStr = bindMobileStr.slice(0, 4) + 'xxxx' + bindMobileStr.slice(bindMobileStr.length - 4, bindMobileStr.length) 

    }
    if (tb_bind_status === 1) {
      // 验证成功
      this.validateStatus = 3
      if (this.bidType === 7 || this.bidType === 8) {
        this.form.sms_code = '您已验证成功'
      } else {
        this.form.amount = '您已验证成功'
      }
    } else {
      if (last_bind_time > 0 && last_bind_time < 24 * 3600) {
        this.validateStatus = 2
        this.showReBtn = true
        this.mobile = `value-name-${tb_bind_mobile}`
      }
    }
    
    if(this.bidType ===3){
      if(!this.form.taxpayer){
        this.form.taxpayer = this.form.business_license 
      }
    }
  }

  async getBankList() {
    this.bankList = await api.getBankList()
  }

  handleRegionChange(value: string[]) {
    this.form.bank_province = value[0]
    this.form.bank_city = value[1]
    this.form.bank_area = value[2]
  }

  startBindBankTimer(restSec: number) {
    if (restSec <= 0) {
      this.btnTimer = 0
      this.validateError = ''
      return
    }
    this.btnTimer = restSec
    this.timer = window.setTimeout(
      () => this.startBindBankTimer(restSec - 1),
      1000
    )
  }

  async askForValidate() {
    if (!this.contacts) {
      let validValue = true
      await (this.$refs.form as any).validate((valid: boolean, e: any) => {
        validValue = valid
        if (!valid) {
          const err: any = Object.values(e)[0]
          this.$message.error(err[0].message)
        }
      })
      if (!validValue) return
      try {
        this.validating = true
        const { taxpayer, tax_invoice_url, ...data } = this.form // eslint-disable-line
        const { mobiles } = await api.openAccount(data)
        this.contacts = mobiles
        this.validateStatus = 1
        this.validateError = ''
        this.validating = false
      } catch (err) {
        this.validating = false
        if (err.code === 2001) {
          // 24小时内申请过绑定
          this.validateStatus = 2
          this.showReBtn = true
          if (err.data.mobile) {
            this.mobile = `value-name-${err.data.mobile}`
            this.tbBindMobile = err.data.mobile
            this.tbBindMobileStr = this.tbBindMobile.slice(0, 4) + 'xxxx' + this.tbBindMobile.slice(this.tbBindMobile.length - 4, this.tbBindMobile.length) 
          }
          this.$info({
            title: '温馨提示',
            content: err.msg,
            okText: '知道了',
          })
        } else {
          this.validateError = err.msg
        }
        throw new Error(err.msg)
      }
    }
    this.showContactsModal = true
  }
  changeMobileFunc(val:any) {
    this.mobile = val
  }

  async bindBank() {
    this.bindingBank = true
    try {
      await api.bindBank({
        bank_account: this.form.bank_account,
        bank_simple_name: this.form.bank_simple_name,
        mobile: this.mobile.split('-')[2] || this.mobile.split('-')[1],
      })
      this.validateStatus = 2
      this.validateError = ''
      this.startBindBankTimer(120)
      this.showReBtn = true
      this.changeMobile = false
      this.tbBindMobile = this.mobile.split('-')[2] || this.mobile.split('-')[1]
      this.tbBindMobileStr = this.tbBindMobile.slice(0, 4) + 'xxxx' + this.tbBindMobile.slice(this.tbBindMobile.length - 4, this.tbBindMobile.length) 
    } catch (err) {
      // 失败后重新走流程
      this.validateStatus = 0
      this.mobile = ''
      this.validateError = err.msg
      this.contacts = null
    }
    this.bindingBank = false
    this.showContactsModal = false
  }

  async bindBankQuery() {
    this.bindBankQuering = true
    try {
      const { status, errorMsg } = await api.bindBankQuery()
      const result = ['成功', '失败', '处理中'][status - 1]
      this.$info({
        title: '查询结果',
        content: (h: CreateElement) =>
          h(
            'div',
            {
              style: 'text-align: left',
            },
            [
              h('p', `银行打款状态：${result}`),
              status === 2 && h('p', { style: 'color: #f5222d' }, errorMsg),
            ]
          ),
        okText: '知道了',
      })
    } catch {}
    this.bindBankQuering = false
  }

  async validate() {
    if (this.bidType !== 7 && this.bidType !== 8 && !this.form.amount) {
      this.validateError = '请填写收到的金额'
      return
    }
    if (!this.form.sms_code) {
      this.validateError = '请填写短信验证码'
      return
    }
    this.validating = true
    try {
      const data = await api.bindBankVerify({
        sms_code: this.form.sms_code,
        ...(this.bidType === 7 ? {} : { amount: this.form.amount }),
      })
      if (data.tb_bind_status === 2) {
        throw new Error('您输入的金额不正确，请重新输入')
      }
      if (data.tb_bind_status === 3) {
        // 处理中
        await this.queryValidateResult(data.tb_bind_verify_seqid)
      }
      await signBehavior()
      this.validating = false
      this.validateStatus = 3
      this.validateError = ''
      this.showReBtn = false
      window.clearTimeout(this.timer)
      if (this.bidType === 7 || this.bidType === 8) {
        this.form.sms_code = '您已验证成功'
      } else {
        this.form.amount = '您已验证成功'
      }
      return true
    } catch (err) {
      this.validating = false
      this.validateError = err.message || err.msg
      if (this.bidType !== 7 && this.bidType !== 8) {
        this.$set(this.form, 'amount', '')
        ;(this.$refs.validateInput as any).focus()
      }
    }
  }

  queryValidateResult(seqId: string) {
    return new Promise((resolve, reject) => {
      window.setTimeout(async () => {
        try {
          const data = await api.bindVerifyQuery(seqId)
          if (data.tb_bind_status === 1) return resolve(1)
          if (data.tb_bind_status === 2)
            return reject(new Error(data.tb_bind_fail_msg))
          resolve(this.queryValidateResult(seqId))
        } catch (err) {
          reject(new Error(err.msg))
        }
      }, 2000)
    })
  }

  async submit() {
    if (this.bidType !== 6 && this.validateStatus < 2) {
      this.scrollIntoView()
      return this.$message.error('请先进行对公银行账号验证')
    }
    let validValue = true
    await (this.$refs.form as any).validate((valid: boolean, e: any) => {
      validValue = valid
      if (!valid) {
        const err: any = Object.values(e)[0]
        this.$message.error(err[0].message)
      }
    })
   // this.bidType !== 6 && this.bidType !== 8
    if (validValue && this.bidType === 3 ) {
      await (this.$refs.taxForm as any).validate((valid: boolean, e: any) => {
        validValue = valid
        if (!valid) {
          const err: any = Object.values(e)[0]
          this.$message.error(err[0].message)
        }
      })
    }

    if (!validValue) return
    this.loading = true
    try {
      if (
        this.bidType !== 6 &&
        this.validateStatus === 2 &&
        !(await this.validate())
      ) {
        this.loading = false
        this.scrollIntoView()
        this.$message.error('对公银行账号验证失败')
        return
      }
      // 非必填项传空字符串
      const defaults = {
        bank_number: '',
        branch_code: '',
        is_osa: '',
        business_license: '',
        bank_cnaps: '',
      }
      const form =
        this.bidType === 6 ? { ...defaults, ...this.form } : this.form
      await api.saveFinanceInfo(form)
      this.$emit('forward')
    } catch (err) {
      console.error(err)
    }
    this.loading = false
  }

  scrollIntoView() {
    const { $el } = this.$refs.validate as any
    if ($el.scrollIntoView) {
      $el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      this.animation = 'animate-shine'
    }
  }

  doTest() {
    const { NODE_ENV, TARGET } = process.env
    if (NODE_ENV === 'development' || TARGET === 'test-build') {
      this.form = { ...this.form, ...financialInfo(this.bidType) }
    }
  }
  async toChangeMobile() {
    if (!this.contacts) {
      try {
        const { mobiles } = await api.getBindMobiles()
        this.contacts = mobiles
        this.showContactsModal = true
        this.changeMobile = true
        mobiles.forEach((el: any) => {
          if (el.mobile === this.tbBindMobile) {
            this.mobile = el.name
          }
        })

      } catch (err) { }
    } else {
      this.showContactsModal = true
      this.changeMobile =true
    }
   
  }

  async handleBankCardChange(info: any) {
    if (info.fileList?.length <= 0) return
    try {
      const data = await api.queryBankCardInfo(this.form.bank_account_url)
      this.form = Object.assign(this.form, {
        bank_account: data.bank_card_number,
        ...(this.bidType == 6 ? {
          bank_name: data.bank_name
        } : {
          bank_simple_name: data.bank_name,
        }),
      })
      this.bankResult = 1
    } catch (e) {
      this.bankResult = -1
      if ((e as any)?.msg) this.$message.error((e as any).msg)
    }
  }
}
